var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.26 4.51999C12.9559 4.51999 13.52 3.95587 13.52 3.26C13.52 2.56412 12.9559 2 12.26 2C11.5641 2 11 2.56412 11 3.26C11 3.95587 11.5641 4.51999 12.26 4.51999Z",
    fill: "#8B8989",
    stroke: "#8B8989",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.26 13.7612C12.9559 13.7612 13.52 13.1971 13.52 12.5012C13.52 11.8053 12.9559 11.2412 12.26 11.2412C11.5641 11.2412 11 11.8053 11 12.5012C11 13.1971 11.5641 13.7612 12.26 13.7612Z",
    fill: "#8B8989",
    stroke: "#8B8989",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.26 22.9995C12.9559 22.9995 13.52 22.4354 13.52 21.7395C13.52 21.0436 12.9559 20.4795 12.26 20.4795C11.5641 20.4795 11 21.0436 11 21.7395C11 22.4354 11.5641 22.9995 12.26 22.9995Z",
    fill: "#8B8989",
    stroke: "#8B8989",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/threedot.8483679f478e5f443f34b09a86c2be78.svg";
export { ForwardRef as ReactComponent };